import axios from "axios";
import store from "./vuex/store";

export default {

  login(credential) {
    return axios.post("/login", credential);
  },
  // register(params) {
  //   return axios.post("/register", params);
  // },

  // getProfile(username) {
  //   return axios.get(`/getProfile/${username}`, {
  //     headers: {
  //       Authorization: "Bearer " + store.getters.getJwt
  //     }
  //   });
  // },



 // start lababiz

 
 changePassword(params) {
  return axios.post(`/changePassword`, params, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  })
},

 getEvent() {
  return axios.get(`/event/getEvent`, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  })
},

getEventAtEvent() {
  return axios.get(`/event/getEventAtEvent`, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  })
},

getEvent_public() {
  return axios.get(`/event/getEvent_public`, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  })
},

getSectionParticipateNumber_public () {
  return axios.get(`/event/getSectionParticipateNumber_public `, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  })
},

getAgeRankParticipateNumber_public() {
  return axios.get(`/event/getAgeRankParticipateNumber_public `, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  })
},

getInterestedParticipateNumber_public() {
  return axios.get(`/event/getInterestedParticipateNumber_public `, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  })
},
getBoothNumber_public() {
  return axios.get(`/event/getBoothNumber_public `, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  })
},

getCompetitionEvent() {
  return axios.get(`/event/getCompetitionEvent`, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  })
},

getEventDetail(eventid) {
  return axios.get(`/event/getEventDetail/${eventid}`, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  })
},

getCompetitionEventDetail(eventid) {
  return axios.get(`/event/getCompetitionEventDetail/${eventid}`, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  })
},

getEventInfo(params) {
  return axios.post(`/event/getEventInfo`, params, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  })
},

getEventInfo_Current(params) {
  return axios.post(`/event/getEventInfo_Current`, params, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  })
},





doregister(params) {
  return axios.post(`/event/doregister`, params, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  });
},

doselfregister(params) {
  return axios.post(`/event/doselfregister`, params, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  });
},

doselfregisterbystaff(params) {
  return axios.post(`/event/doselfregisterbystaff`, params, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  });
},





searchRegsiterByPhoneno(params) {
  return axios.post(`/event/searchRegsiterByPhoneno`, params, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  });
},

searchRegsiterByPhoneno_public(params) {
  return axios.post(`/event/searchRegsiterByPhoneno_public`, params, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  });
},



getSection() {
  return axios.get(`/event/getSection`, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  })
},

getGender() {
  return axios.get(`/event/getGender`, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  })
},

getBusinessGroup() {
  return axios.get(`/event/getBusinessGroup`, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  })
},

getAgeRang() {
  return axios.get(`/event/getAgeRang`, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  })
},

getRankList() {
  return axios.get(`/event/getRankList`, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  })
},


getInterested() {
  return axios.get(`/event/getInterested`, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  })
},

doEditRegister(params) {
  return axios.post(`/event/doEditRegister`, params, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  });
},



joinEvent(params) {
  return axios.post(`/event/joinEvent`, params, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  });
},

doSaveEvent(params) {
  return axios.post(`/event/doSaveEvent`, params, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  });
},



doEditEvent(params) {
  return axios.post(`/event/doEditEvent`, params, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  });
},

changeEventStatus(params) {
  return axios.post(`/event/changeEventStatus`, params, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  });
},

doSaveBooth(params) {
  return axios.post(`/event/doSaveBooth`, params, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  });
},


getEventBooth() {
  return axios.get(`/event/getEventBooth`, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  })
},

getEventBoothSummaryReport() {
  return axios.get(`/event/getEventBoothSummaryReport`, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  })
},


getDataByRegNo(params) {
  return axios.post(`/event/getDataByRegNo`, params, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  });
},

checkEventParticipate(params) {
  return axios.post(`/event/checkEventParticipate`, params, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  });
},

doRegisterParticipateCompetition(params) {
  return axios.post(`/event/doRegisterParticipateCompetition`, params, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  });
},

doEditParticipateCompetition(params) {
  return axios.post(`/event/doEditParticipateCompetition`, params, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  });
},

saveCompetitionResult(params) {
  return axios.post(`/event/saveCompetitionResult`, params, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  });
},

confirmCompetitionResult(params) {
  return axios.post(`/event/confirmCompetitionResult`, params, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  });
},

cancelCompetitionResult(params) {
  return axios.post(`/event/cancelCompetitionResult`, params, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  });
},

saveBusinessInfo(params) {
  return axios.post(`/event/saveBusinessInfo`, params, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  });
},

saveBusinessInfo_public(params) {
  return axios.post(`/event/saveBusinessInfo_public`, params);
},


getBusinessInfo(params) {
  return axios.post(`/event/getBusinessInfo`, params, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  });
},

getBusinessInfo_public(params) {
  return axios.post(`/event/getBusinessInfo_public`, params);
},

getBusinessType(params) {
  return axios.post(`/event/getBusinessType`, params, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  });
},

getBusinessType_public(params) {
  return axios.post(`/event/getBusinessType_public`, params);
},

interestedIn(params) {
  return axios.post(`/event/interestedIn`, params, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  });
},

interestedIn_public(params) {
  return axios.post(`/event/interestedIn_public`, params);
},

doMemberRegister(params) {
  return axios.post(`/event/doMemberRegister`, params, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  });
},

doSelfMemberRegister(params) {
  return axios.post(`/event/doSelfMemberRegister`, params);
},

getMemberList(params) {
  return axios.post(`/event/getMemberList`, params, {
    headers: {
      Authorization: "Bearer " + store.getters.getJwt
    }
  });
},

 // end lababiz











};